export default "__VITE_ASSET__41be3c62__"